export const AUDIENCES = [
  {
    id: "college",
    code: "COL",
    title: "For Colleges",
    tag: "Institutional flagship",
    forWhom:
      "Engineering, commerce, arts undergraduates. Institutions as buyers.",
    bullets: [
      "The full 17-module flagship",
      "Pod structure with peer cohorts",
      "Innovation Arena edition on campus",
      "Industry judges & top-pod incubation pathway",
      "MoU support and certificate co-signing",
    ],
    cta: "Bring AI For Everyone to your campus",
  },
  {
    id: "corporate",
    code: "COR",
    title: "For Corporates",
    tag: "Workforce capability",
    forWhom:
      "L&D teams, function leaders, executives. Companies as buyers.",
    bullets: [
      "Function tracks: Sales, Marketing, HR, Finance, Legal",
      "Leadership tracks (Chief AI Officer)",
      "Custom case studies on your data",
      "Executive briefings",
      "Train-the-trainer programs",
    ],
    cta: "Build AI capability across your workforce",
  },
  {
    id: "individual",
    code: "IND",
    title: "For Individuals",
    tag: "Self-paced + cohort",
    forWhom: "Self-paced learners, professionals, career-pivoters.",
    bullets: [
      "11 launch certifications",
      "3 tiers (Native, Builder, Leader)",
      "Portfolio-ready capstone artifacts",
      "Community & mentor access",
      "Job and pitch opportunities",
    ],
    cta: "Find your starting point",
  },
  {
    id: "school",
    code: "SCH",
    title: "For Schools",
    tag: "Early-stage AI literacy",
    forWhom: "Class 6 to Class 12 students. Parents and schools as buyers.",
    bullets: [
      "AI Essentials for all students",
      "Teacher training",
      "Parent orientation sessions",
      "Annual AI Day",
      "Branded co-deployment",
    ],
    cta: "Bring AI literacy to your school",
  },
];
